import { ApiBase } from "../../base/_ApiBase";
import { UserGroupModel } from "../../models/users-group/UserGroupModel";

export const UserGroupApi = new class UserGroupApi extends ApiBase<UserGroupModel>{
    constructor({ baseUrl }: { baseUrl: string; }) {
        super(baseUrl);
    }
}({ baseUrl: '/users-group' });